import http from "services/http";

export interface Coupon {
  _id: string;
  name: string;
  code: string;
  expire: string;
  type: "fixed" | "percentage";
  percentage?: number; // Optional, used when type is percentage
  amount?: number; // Optional, used when type is fixed
}

export interface CreateCouponPayload {
  name: string;
  expire: string;
  type: "fixed" | "percentage";
  percentage?: number; // Optional, used when type is percentage
  amount?: number; // Optional, used when type is fixed
  code?: string; // Optional, if you want to set a custom code
}

export interface CouponResponse {
  data: {
    coupons: Coupon[];
  };
}

export const createCoupon = async (payload: CreateCouponPayload) => {
  const response = await http.post("admin/createcoupon", payload);
  return response.data;
};

export const getCoupons = async (): Promise<CouponResponse> => {
  const response = await http.get("admin/getcoupon");
  return response.data;
};

export interface EditCouponPayload extends CreateCouponPayload {
  _id: string;
}

export const editCoupon = async (payload: EditCouponPayload) => {
  const { _id, ...couponData } = payload;
  const response = await http.post(`admin/editcoupon/${_id}`, couponData);
  return response.data;
};
